export default __webpack_public_path__ + "assets/images/Payment_05.820f3b.webp";